/* FW shared NZ postcode -> province/city lookup (2026-09-08). Same table as main-cart-footer + fw-pdp-shipping-estimator. Exposes window.fwRegionForPostcode(zip) -> {province,city}|null */
(function(){
var NZ_POSTCODE_LOCALITIES = {
      '1010': { province: "Auckland", city: "Auckland" },
      '2120': { province: "Auckland", city: "Pukekohe" },
      '3010': { province: "Bay of Plenty", city: "Rotorua" },
      '3110': { province: "Bay of Plenty", city: "Tauranga" },
      '3204': { province: "Waikato", city: "Hamilton" },
      '4010': { province: "Gisborne", city: "Gisborne" },
      '4110': { province: "Hawke's Bay", city: "Napier" },
      '4310': { province: "Taranaki", city: "New Plymouth" },
      '4410': { province: "Manawatu-Wanganui", city: "Palmerston North" },
      '4500': { province: "Manawatu-Wanganui", city: "Whanganui" },
      '5510': { province: "Manawatu-Wanganui", city: "Levin" },
      '5810': { province: "Wellington", city: "Masterton" },
      '7010': { province: "Nelson", city: "Nelson" },
      '7201': { province: "Marlborough", city: "Blenheim" },
      '7805': { province: "West Coast", city: "Greymouth" },
      '7910': { province: "Canterbury", city: "Timaru" },
      '8011': { province: "Canterbury", city: "Christchurch" },
      '9016': { province: "Otago", city: "Dunedin" },
      '9300': { province: "Otago", city: "Queenstown" },
      '9400': { province: "Otago", city: "Oamaru" },
      '9810': { province: "Southland", city: "Invercargill" },
      '0110': { province: "Northland", city: "Whangarei" },
      '0230': { province: "Northland", city: "Kerikeri" },
      '0612': { province: "Auckland", city: "Auckland" }
    };

    // Complete known NZ postcode dataset, compressed into contiguous postcode ranges.
    // A missing code is never guessed: the estimator fails closed to checkout.
    var NZ_POSTCODE_LOCALITY_RANGES = [
      [110, 110, "Northland", "Whangarei"],
      [112, 112, "Northland", "Whangarei"],
      [114, 114, "Northland", "Whangarei"],
      [116, 116, "Northland", "Ruakaka"],
      [140, 154, "Northland", "Whangarei"],
      [170, 171, "Northland", "Whangarei"],
      [172, 172, "Northland", "Dargaville"],
      [173, 176, "Northland", "Whangarei"],
      [178, 178, "Northland", "Dargaville"],
      [179, 179, "Northland", "Whangarei"],
      [181, 181, "Northland", "Whangarei"],
      [182, 182, "Northland", "Kerikeri"],
      [184, 185, "Northland", "Whangarei"],
      [192, 192, "Northland", "Whangarei"],
      [193, 193, "Northland", "Dargaville"],
      [200, 200, "Northland", "Kerikeri"],
      [202, 202, "Northland", "Russell"],
      [210, 210, "Northland", "Kawakawa"],
      [211, 211, "Northland", "Moerewa"],
      [230, 230, "Northland", "Kerikeri"],
      [241, 247, "Northland", "Kerikeri"],
      [271, 272, "Northland", "Kerikeri"],
      [281, 283, "Northland", "Kerikeri"],
      [293, 295, "Northland", "Kerikeri"],
      [310, 310, "Northland", "Dargaville"],
      [340, 341, "Northland", "Dargaville"],
      [370, 374, "Northland", "Dargaville"],
      [376, 377, "Northland", "Dargaville"],
      [379, 379, "Northland", "Dargaville"],
      [381, 381, "Northland", "Dargaville"],
      [391, 391, "Northland", "Dargaville"],
      [405, 405, "Northland", "Kaikohe"],
      [410, 410, "Northland", "Kaitaia"],
      [420, 420, "Northland", "Kerikeri"],
      [440, 449, "Northland", "Kerikeri"],
      [451, 451, "Northland", "Kerikeri"],
      [453, 453, "Northland", "Kerikeri"],
      [460, 460, "Northland", "Kerikeri"],
      [462, 462, "Northland", "Kerikeri"],
      [472, 476, "Northland", "Kerikeri"],
      [478, 479, "Northland", "Kerikeri"],
      [481, 484, "Northland", "Kerikeri"],
      [486, 486, "Northland", "Kerikeri"],
      [491, 492, "Northland", "Kerikeri"],
      [494, 494, "Northland", "Kerikeri"],
      [496, 496, "Northland", "Kerikeri"],
      [505, 505, "Northland", "Dargaville"],
      [510, 510, "Northland", "Waipu"],
      [520, 520, "Northland", "Dargaville"],
      [530, 530, "Northland", "Ruawai"],
      [540, 543, "Northland", "Dargaville"],
      [545, 545, "Northland", "Whangarei"],
      [547, 547, "Northland", "Dargaville"],
      [549, 550, "Northland", "Dargaville"],
      [571, 571, "Northland", "Dargaville"],
      [573, 573, "Northland", "Dargaville"],
      [582, 582, "Northland", "Whangarei"],
      [583, 583, "Northland", "Dargaville"],
      [587, 589, "Northland", "Dargaville"],
      [591, 594, "Northland", "Dargaville"],
      [600, 600, "Auckland", "Auckland"],
      [602, 602, "Auckland", "Auckland"],
      [604, 604, "Auckland", "Auckland"],
      [610, 610, "Auckland", "Auckland"],
      [612, 612, "Auckland", "Auckland"],
      [614, 614, "Auckland", "Auckland"],
      [618, 618, "Auckland", "Auckland"],
      [620, 620, "Auckland", "Auckland"],
      [622, 622, "Auckland", "Auckland"],
      [624, 624, "Auckland", "Auckland"],
      [626, 627, "Auckland", "Auckland"],
      [629, 630, "Auckland", "Auckland"],
      [632, 632, "Auckland", "Auckland"],
      [640, 645, "Auckland", "Auckland"],
      [650, 657, "Auckland", "Auckland"],
      [660, 663, "Auckland", "Auckland"],
      [740, 758, "Auckland", "Auckland"],
      [772, 772, "Auckland", "Auckland"],
      [781, 782, "Auckland", "Auckland"],
      [792, 794, "Auckland", "Auckland"],
      [800, 800, "Auckland", "Helensville"],
      [810, 810, "Auckland", "Auckland"],
      [812, 812, "Auckland", "Waimauku"],
      [814, 814, "Auckland", "Auckland"],
      [820, 820, "Auckland", "Riverhead"],
      [830, 830, "Auckland", "Parakai"],
      [840, 843, "Auckland", "Auckland"],
      [871, 871, "Auckland", "Auckland"],
      [873, 875, "Auckland", "Auckland"],
      [881, 883, "Auckland", "Auckland"],
      [891, 892, "Auckland", "Auckland"],
      [900, 900, "Auckland", "Wellsford"],
      [910, 910, "Auckland", "Warkworth"],
      [920, 920, "Auckland", "Auckland"],
      [930, 932, "Auckland", "Auckland"],
      [940, 948, "Auckland", "Auckland"],
      [950, 951, "Auckland", "Auckland"],
      [960, 963, "Auckland", "Auckland"],
      [972, 974, "Auckland", "Auckland"],
      [975, 975, "Northland", "Dargaville"],
      [977, 977, "Auckland", "Auckland"],
      [981, 986, "Auckland", "Auckland"],
      [991, 993, "Auckland", "Auckland"],
      [1010, 1011, "Auckland", "Auckland"],
      [1021, 1026, "Auckland", "Auckland"],
      [1041, 1042, "Auckland", "Auckland"],
      [1050, 1052, "Auckland", "Auckland"],
      [1060, 1062, "Auckland", "Auckland"],
      [1071, 1072, "Auckland", "Auckland"],
      [1081, 1081, "Auckland", "Auckland"],
      [1140, 1145, "Auckland", "Auckland"],
      [1147, 1151, "Auckland", "Auckland"],
      [1245, 1246, "Auckland", "Auckland"],
      [1340, 1340, "Auckland", "Auckland"],
      [1342, 1342, "Auckland", "Auckland"],
      [1344, 1352, "Auckland", "Auckland"],
      [1440, 1440, "Auckland", "Auckland"],
      [1443, 1443, "Auckland", "Auckland"],
      [1445, 1446, "Auckland", "Auckland"],
      [1541, 1546, "Auckland", "Auckland"],
      [1640, 1643, "Auckland", "Auckland"],
      [1740, 1746, "Auckland", "Auckland"],
      [1840, 1843, "Auckland", "Auckland"],
      [1971, 1971, "Auckland", "Auckland"],
      [2010, 2010, "Auckland", "Auckland"],
      [2012, 2014, "Auckland", "Auckland"],
      [2016, 2016, "Auckland", "Auckland"],
      [2018, 2018, "Auckland", "Auckland"],
      [2022, 2025, "Auckland", "Auckland"],
      [2102, 2105, "Auckland", "Auckland"],
      [2110, 2110, "Auckland", "Auckland"],
      [2112, 2113, "Auckland", "Auckland"],
      [2120, 2120, "Auckland", "Pukekohe"],
      [2121, 2121, "Waikato", "Hamilton"],
      [2122, 2123, "Auckland", "Auckland"],
      [2140, 2151, "Auckland", "Auckland"],
      [2153, 2160, "Auckland", "Auckland"],
      [2240, 2248, "Auckland", "Auckland"],
      [2340, 2341, "Auckland", "Auckland"],
      [2342, 2342, "Waikato", "Hamilton"],
      [2343, 2345, "Auckland", "Auckland"],
      [2440, 2441, "Waikato", "Hamilton"],
      [2471, 2471, "Auckland", "Auckland"],
      [2472, 2474, "Waikato", "Hamilton"],
      [2571, 2571, "Auckland", "Auckland"],
      [2576, 2580, "Auckland", "Auckland"],
      [2582, 2585, "Auckland", "Auckland"],
      [2675, 2676, "Auckland", "Auckland"],
      [2677, 2677, "Waikato", "Hamilton"],
      [2678, 2679, "Auckland", "Auckland"],
      [2681, 2681, "Waikato", "Hamilton"],
      [2682, 2684, "Auckland", "Auckland"],
      [2693, 2697, "Waikato", "Hamilton"],
      [3010, 3010, "Bay of Plenty", "Rotorua"],
      [3015, 3015, "Bay of Plenty", "Rotorua"],
      [3020, 3020, "Bay of Plenty", "Rotorua"],
      [3025, 3025, "Bay of Plenty", "Whakatane"],
      [3040, 3049, "Bay of Plenty", "Rotorua"],
      [3060, 3060, "Waikato", "Rotorua"],
      [3062, 3062, "Bay of Plenty", "Whakatane"],
      [3072, 3072, "Waikato", "Tokoroa"],
      [3073, 3073, "Waikato", "Rotorua"],
      [3074, 3074, "Bay of Plenty", "Rotorua"],
      [3076, 3077, "Bay of Plenty", "Rotorua"],
      [3078, 3078, "Waikato", "Tokoroa"],
      [3079, 3079, "Bay of Plenty", "Whakatane"],
      [3081, 3081, "Waikato", "Taupo"],
      [3083, 3083, "Waikato", "Rotorua"],
      [3110, 3110, "Bay of Plenty", "Tauranga"],
      [3112, 3112, "Bay of Plenty", "Tauranga"],
      [3114, 3114, "Bay of Plenty", "Tauranga"],
      [3116, 3116, "Bay of Plenty", "Tauranga"],
      [3118, 3119, "Bay of Plenty", "Tauranga"],
      [3120, 3121, "Bay of Plenty", "Whakatane"],
      [3122, 3122, "Bay of Plenty", "Opotiki"],
      [3123, 3123, "Bay of Plenty", "Whakatane"],
      [3127, 3127, "Bay of Plenty", "Kawerau"],
      [3129, 3129, "Bay of Plenty", "Tauranga"],
      [3140, 3154, "Bay of Plenty", "Tauranga"],
      [3158, 3161, "Bay of Plenty", "Whakatane"],
      [3162, 3162, "Bay of Plenty", "Opotiki"],
      [3163, 3164, "Bay of Plenty", "Whakatane"],
      [3166, 3166, "Bay of Plenty", "Tauranga"],
      [3167, 3168, "Bay of Plenty", "Whakatane"],
      [3169, 3169, "Bay of Plenty", "Kawerau"],
      [3171, 3173, "Bay of Plenty", "Tauranga"],
      [3175, 3178, "Bay of Plenty", "Tauranga"],
      [3182, 3183, "Bay of Plenty", "Tauranga"],
      [3186, 3189, "Bay of Plenty", "Tauranga"],
      [3191, 3191, "Bay of Plenty", "Whakatane"],
      [3192, 3192, "Bay of Plenty", "Kawerau"],
      [3193, 3193, "Bay of Plenty", "Whakatane"],
      [3194, 3194, "Bay of Plenty", "Tauranga"],
      [3196, 3196, "Bay of Plenty", "Whakatane"],
      [3197, 3198, "Bay of Plenty", "Opotiki"],
      [3199, 3199, "Gisborne", "Gisborne"],
      [3200, 3200, "Waikato", "Avalon Industrial"],
      [3204, 3204, "Waikato", "Hamilton"],
      [3206, 3206, "Waikato", "Bader"],
      [3210, 3210, "Waikato", "Hamilton"],
      [3214, 3214, "Waikato", "Claudelands"],
      [3216, 3216, "Waikato", "Hamilton East"],
      [3218, 3218, "Waikato", "Temple View"],
      [3225, 3225, "Waikato", "Hamilton"],
      [3240, 3240, "Waikato", "Hamilton West"],
      [3241, 3241, "Waikato", "Te Rapa"],
      [3242, 3242, "Waikato", "Hamilton West"],
      [3243, 3243, "Waikato", "Frankton Junction"],
      [3244, 3244, "Waikato", "Hamilton"],
      [3245, 3246, "Waikato", "Melville"],
      [3247, 3247, "Waikato", "Hamilton East"],
      [3248, 3248, "Waikato", "Claudelands"],
      [3249, 3249, "Waikato", "Te Rapa"],
      [3251, 3251, "Waikato", "Hamilton East"],
      [3252, 3252, "Waikato", "Claudelands"],
      [3253, 3254, "Waikato", "Newstead"],
      [3255, 3255, "Waikato", "Hamilton East"],
      [3256, 3257, "Waikato", "Claudelands"],
      [3260, 3266, "Waikato", "Hamilton"],
      [3281, 3281, "Waikato", "Hamilton"],
      [3282, 3282, "Waikato", "Cambridge"],
      [3283, 3285, "Waikato", "Hamilton"],
      [3288, 3289, "Waikato", "Hamilton"],
      [3290, 3290, "Waikato", "Temple View"],
      [3293, 3293, "Waikato", "Hamilton"],
      [3295, 3297, "Waikato", "Hamilton"],
      [3300, 3300, "Waikato", "Matamata"],
      [3310, 3310, "Waikato", "Matamata"],
      [3320, 3320, "Waikato", "Matamata"],
      [3330, 3330, "Waikato", "Taupo"],
      [3332, 3332, "Waikato", "Taupo"],
      [3334, 3334, "Waikato", "Taupo"],
      [3340, 3343, "Waikato", "Matamata"],
      [3351, 3353, "Waikato", "Taupo"],
      [3360, 3360, "Waikato", "Taupo"],
      [3371, 3374, "Waikato", "Matamata"],
      [3375, 3375, "Waikato", "Hamilton"],
      [3377, 3378, "Waikato", "Taupo"],
      [3379, 3379, "Hawke's Bay", "Taupo"],
      [3380, 3380, "Waikato", "Matamata"],
      [3381, 3382, "Waikato", "Taupo"],
      [3391, 3393, "Waikato", "Matamata"],
      [3400, 3401, "Waikato", "Matamata"],
      [3410, 3411, "Waikato", "Tokoroa"],
      [3415, 3415, "Waikato", "Tokoroa"],
      [3420, 3420, "Waikato", "Tokoroa"],
      [3421, 3421, "Waikato", "Taupo"],
      [3432, 3432, "Waikato", "Cambridge"],
      [3434, 3434, "Waikato", "Cambridge"],
      [3440, 3441, "Waikato", "Matamata"],
      [3442, 3444, "Waikato", "Tokoroa"],
      [3445, 3445, "Waikato", "Taupo"],
      [3450, 3451, "Waikato", "Cambridge"],
      [3471, 3475, "Waikato", "Matamata"],
      [3481, 3483, "Waikato", "Tokoroa"],
      [3484, 3485, "Waikato", "Matamata"],
      [3491, 3491, "Waikato", "Tokoroa"],
      [3492, 3492, "Waikato", "Otorohanga"],
      [3493, 3493, "Waikato", "Hamilton"],
      [3494, 3495, "Waikato", "Cambridge"],
      [3496, 3496, "Waikato", "Matamata"],
      [3500, 3500, "Waikato", "Thames"],
      [3503, 3503, "Waikato", "Paeroa"],
      [3506, 3506, "Waikato", "Thames"],
      [3508, 3508, "Waikato", "Thames"],
      [3510, 3510, "Waikato", "Thames"],
      [3540, 3540, "Waikato", "Thames"],
      [3541, 3541, "Waikato", "Paeroa"],
      [3542, 3544, "Waikato", "Thames"],
      [3545, 3545, "Waikato", "Paeroa"],
      [3546, 3547, "Waikato", "Thames"],
      [3574, 3574, "Waikato", "Paeroa"],
      [3575, 3575, "Waikato", "Thames"],
      [3576, 3576, "Waikato", "Paeroa"],
      [3577, 3579, "Waikato", "Thames"],
      [3581, 3583, "Waikato", "Thames"],
      [3584, 3584, "Waikato", "Colville"],
      [3591, 3592, "Waikato", "Thames"],
      [3597, 3597, "Waikato", "Paeroa"],
      [3600, 3600, "Waikato", "Paeroa"],
      [3610, 3610, "Waikato", "Paeroa"],
      [3611, 3611, "Bay of Plenty", "Tauranga"],
      [3620, 3620, "Waikato", "Thames"],
      [3640, 3641, "Waikato", "Paeroa"],
      [3642, 3642, "Bay of Plenty", "Tauranga"],
      [3643, 3643, "Waikato", "Thames"],
      [3671, 3672, "Waikato", "Paeroa"],
      [3673, 3673, "Waikato", "Matamata"],
      [3674, 3674, "Waikato", "Paeroa"],
      [3681, 3682, "Waikato", "Paeroa"],
      [3691, 3691, "Waikato", "Paeroa"],
      [3700, 3700, "Waikato", "Hamilton"],
      [3710, 3710, "Waikato", "Hamilton"],
      [3720, 3721, "Waikato", "Hamilton"],
      [3740, 3742, "Waikato", "Hamilton"],
      [3771, 3772, "Waikato", "Hamilton"],
      [3781, 3782, "Waikato", "Hamilton"],
      [3784, 3784, "Waikato", "Matamata"],
      [3791, 3794, "Waikato", "Hamilton"],
      [3800, 3800, "Waikato", "Cambridge"],
      [3802, 3803, "Waikato", "Cambridge"],
      [3840, 3841, "Waikato", "Cambridge"],
      [3843, 3843, "Waikato", "Otorohanga"],
      [3872, 3873, "Waikato", "Cambridge"],
      [3874, 3874, "Waikato", "Otorohanga"],
      [3875, 3877, "Waikato", "Cambridge"],
      [3878, 3878, "Waikato", "Otorohanga"],
      [3879, 3883, "Waikato", "Cambridge"],
      [3885, 3886, "Waikato", "Otorohanga"],
      [3889, 3889, "Waikato", "Otorohanga"],
      [3894, 3895, "Waikato", "Hamilton"],
      [3900, 3900, "Waikato", "Otorohanga"],
      [3910, 3910, "Waikato", "Te Kuiti"],
      [3912, 3912, "Waikato", "Te Kuiti"],
      [3920, 3920, "Manawatu-Wanganui", "Taumarunui"],
      [3924, 3924, "Manawatu-Wanganui", "Taumarunui"],
      [3926, 3926, "Manawatu-Wanganui", "Taumarunui"],
      [3940, 3940, "Waikato", "Otorohanga"],
      [3941, 3945, "Waikato", "Te Kuiti"],
      [3946, 3949, "Manawatu-Wanganui", "Taumarunui"],
      [3970, 3971, "Waikato", "Te Kuiti"],
      [3972, 3976, "Waikato", "Otorohanga"],
      [3977, 3978, "Waikato", "Te Kuiti"],
      [3979, 3979, "Manawatu-Wanganui", "Taumarunui"],
      [3980, 3980, "Manawatu-Wanganui", "Stratford"],
      [3981, 3983, "Waikato", "Te Kuiti"],
      [3985, 3985, "Waikato", "Te Kuiti"],
      [3986, 3986, "Waikato", "Otorohanga"],
      [3987, 3988, "Waikato", "Te Kuiti"],
      [3989, 3998, "Manawatu-Wanganui", "Taumarunui"],
      [4010, 4010, "Gisborne", "Gisborne"],
      [4022, 4022, "Gisborne", "Gisborne"],
      [4032, 4032, "Gisborne", "Gisborne"],
      [4040, 4052, "Gisborne", "Gisborne"],
      [4071, 4073, "Gisborne", "Gisborne"],
      [4075, 4075, "Gisborne", "Gisborne"],
      [4077, 4079, "Gisborne", "Gisborne"],
      [4081, 4083, "Gisborne", "Gisborne"],
      [4086, 4087, "Gisborne", "Gisborne"],
      [4091, 4094, "Gisborne", "Gisborne"],
      [4102, 4102, "Hawke's Bay", "Hastings"],
      [4104, 4104, "Hawke's Bay", "Napier"],
      [4108, 4108, "Hawke's Bay", "Wairoa"],
      [4110, 4110, "Hawke's Bay", "Napier"],
      [4112, 4112, "Hawke's Bay", "Napier"],
      [4120, 4120, "Hawke's Bay", "Hastings"],
      [4122, 4122, "Hawke's Bay", "Hastings"],
      [4130, 4130, "Hawke's Bay", "Hastings"],
      [4140, 4147, "Hawke's Bay", "Napier"],
      [4148, 4148, "Hawke's Bay", "Hastings"],
      [4149, 4149, "Hawke's Bay", "Napier"],
      [4153, 4159, "Hawke's Bay", "Hastings"],
      [4160, 4160, "Hawke's Bay", "Wairoa"],
      [4161, 4162, "Hawke's Bay", "Hastings"],
      [4163, 4166, "Hawke's Bay", "Wairoa"],
      [4171, 4172, "Hawke's Bay", "Hastings"],
      [4174, 4175, "Hawke's Bay", "Hastings"],
      [4178, 4178, "Hawke's Bay", "Waipukurau"],
      [4179, 4179, "Hawke's Bay", "Hastings"],
      [4181, 4182, "Hawke's Bay", "Hastings"],
      [4183, 4183, "Hawke's Bay", "Napier"],
      [4184, 4184, "Hawke's Bay", "Hastings"],
      [4186, 4186, "Hawke's Bay", "Hastings"],
      [4188, 4188, "Hawke's Bay", "Hastings"],
      [4189, 4189, "Hawke's Bay", "Wairoa"],
      [4191, 4191, "Hawke's Bay", "Wairoa"],
      [4193, 4193, "Hawke's Bay", "Wairoa"],
      [4195, 4198, "Hawke's Bay", "Wairoa"],
      [4200, 4200, "Hawke's Bay", "Waipukurau"],
      [4202, 4203, "Hawke's Bay", "Waipukurau"],
      [4210, 4210, "Hawke's Bay", "Waipukurau"],
      [4240, 4245, "Hawke's Bay", "Waipukurau"],
      [4271, 4275, "Hawke's Bay", "Waipukurau"],
      [4276, 4276, "Hawke's Bay", "Hastings"],
      [4277, 4279, "Hawke's Bay", "Waipukurau"],
      [4281, 4288, "Hawke's Bay", "Waipukurau"],
      [4291, 4293, "Hawke's Bay", "Waipukurau"],
      [4294, 4294, "Hawke's Bay", "Hastings"],
      [4295, 4295, "Hawke's Bay", "Waipukurau"],
      [4310, 4310, "Taranaki", "New Plymouth"],
      [4312, 4312, "Taranaki", "New Plymouth"],
      [4314, 4314, "Taranaki", "New Plymouth"],
      [4320, 4320, "Taranaki", "New Plymouth"],
      [4322, 4322, "Taranaki", "Hawera"],
      [4330, 4330, "Taranaki", "New Plymouth"],
      [4332, 4332, "Taranaki", "Stratford"],
      [4335, 4335, "Taranaki", "New Plymouth"],
      [4340, 4349, "Taranaki", "New Plymouth"],
      [4350, 4350, "Waikato", "Te Kuiti"],
      [4351, 4351, "Taranaki", "New Plymouth"],
      [4352, 4352, "Taranaki", "Stratford"],
      [4353, 4353, "Taranaki", "Hawera"],
      [4360, 4360, "Taranaki", "New Plymouth"],
      [4371, 4375, "Taranaki", "New Plymouth"],
      [4376, 4376, "Waikato", "Te Kuiti"],
      [4377, 4379, "Taranaki", "New Plymouth"],
      [4381, 4383, "Taranaki", "New Plymouth"],
      [4386, 4386, "Taranaki", "New Plymouth"],
      [4387, 4387, "Taranaki", "Stratford"],
      [4388, 4389, "Taranaki", "New Plymouth"],
      [4390, 4390, "Taranaki", "Stratford"],
      [4391, 4391, "Taranaki", "Hawera"],
      [4392, 4392, "Manawatu-Wanganui", "Stratford"],
      [4393, 4393, "Taranaki", "Stratford"],
      [4394, 4394, "Taranaki", "New Plymouth"],
      [4395, 4395, "Taranaki", "Stratford"],
      [4396, 4396, "Manawatu-Wanganui", "Stratford"],
      [4397, 4397, "Taranaki", "Stratford"],
      [4398, 4399, "Taranaki", "Hawera"],
      [4410, 4410, "Manawatu-Wanganui", "Palmerston North"],
      [4412, 4412, "Manawatu-Wanganui", "Feilding"],
      [4414, 4414, "Manawatu-Wanganui", "Palmerston North"],
      [4440, 4446, "Manawatu-Wanganui", "Palmerston North"],
      [4448, 4448, "Manawatu-Wanganui", "Palmerston North"],
      [4470, 4470, "Manawatu-Wanganui", "Feilding"],
      [4471, 4471, "Manawatu-Wanganui", "Dannevirke"],
      [4473, 4473, "Manawatu-Wanganui", "Feilding"],
      [4474, 4474, "Manawatu-Wanganui", "Levin"],
      [4475, 4475, "Manawatu-Wanganui", "Palmerston North"],
      [4476, 4476, "Manawatu-Wanganui", "Feilding"],
      [4477, 4477, "Manawatu-Wanganui", "Levin"],
      [4478, 4479, "Manawatu-Wanganui", "Feilding"],
      [4481, 4481, "Manawatu-Wanganui", "Feilding"],
      [4500, 4501, "Manawatu-Wanganui", "Whanganui"],
      [4510, 4510, "Taranaki", "Hawera"],
      [4520, 4520, "Taranaki", "Hawera"],
      [4540, 4540, "Taranaki", "Hawera"],
      [4541, 4543, "Manawatu-Wanganui", "Whanganui"],
      [4544, 4545, "Taranaki", "Hawera"],
      [4547, 4548, "Manawatu-Wanganui", "Marton"],
      [4549, 4549, "Taranaki", "Hawera"],
      [4571, 4572, "Manawatu-Wanganui", "Whanganui"],
      [4573, 4573, "Manawatu-Wanganui", "Taumarunui"],
      [4574, 4575, "Manawatu-Wanganui", "Whanganui"],
      [4576, 4576, "Manawatu-Wanganui", "Taumarunui"],
      [4577, 4577, "Manawatu-Wanganui", "Whanganui"],
      [4578, 4578, "Taranaki", "Hawera"],
      [4581, 4581, "Manawatu-Wanganui", "Marton"],
      [4582, 4582, "Manawatu-Wanganui", "Whanganui"],
      [4584, 4587, "Manawatu-Wanganui", "Whanganui"],
      [4588, 4588, "Taranaki", "Hawera"],
      [4591, 4592, "Taranaki", "Hawera"],
      [4597, 4598, "Taranaki", "Hawera"],
      [4610, 4610, "Taranaki", "Hawera"],
      [4612, 4612, "Taranaki", "Hawera"],
      [4614, 4614, "Taranaki", "Hawera"],
      [4616, 4616, "Taranaki", "Hawera"],
      [4625, 4625, "Manawatu-Wanganui", "Taumarunui"],
      [4632, 4632, "Manawatu-Wanganui", "Taumarunui"],
      [4640, 4642, "Taranaki", "Hawera"],
      [4645, 4645, "Taranaki", "Hawera"],
      [4646, 4646, "Manawatu-Wanganui", "Taumarunui"],
      [4660, 4660, "Manawatu-Wanganui", "Taumarunui"],
      [4671, 4675, "Taranaki", "Hawera"],
      [4678, 4679, "Taranaki", "Hawera"],
      [4681, 4682, "Taranaki", "Hawera"],
      [4684, 4685, "Taranaki", "Hawera"],
      [4691, 4691, "Manawatu-Wanganui", "Taumarunui"],
      [4694, 4694, "Manawatu-Wanganui", "Taumarunui"],
      [4696, 4696, "Manawatu-Wanganui", "Taumarunui"],
      [4702, 4702, "Manawatu-Wanganui", "Feilding"],
      [4710, 4710, "Manawatu-Wanganui", "Marton"],
      [4720, 4720, "Manawatu-Wanganui", "Marton"],
      [4730, 4730, "Manawatu-Wanganui", "Marton"],
      [4740, 4740, "Manawatu-Wanganui", "Feilding"],
      [4741, 4742, "Manawatu-Wanganui", "Marton"],
      [4744, 4744, "Manawatu-Wanganui", "Feilding"],
      [4745, 4746, "Manawatu-Wanganui", "Marton"],
      [4771, 4771, "Manawatu-Wanganui", "Feilding"],
      [4774, 4774, "Manawatu-Wanganui", "Marton"],
      [4775, 4775, "Manawatu-Wanganui", "Palmerston North"],
      [4777, 4777, "Manawatu-Wanganui", "Feilding"],
      [4779, 4780, "Manawatu-Wanganui", "Feilding"],
      [4781, 4789, "Manawatu-Wanganui", "Marton"],
      [4791, 4791, "Manawatu-Wanganui", "Marton"],
      [4792, 4792, "Hawke's Bay", "Marton"],
      [4793, 4796, "Manawatu-Wanganui", "Marton"],
      [4797, 4797, "Manawatu-Wanganui", "Feilding"],
      [4810, 4810, "Manawatu-Wanganui", "Palmerston North"],
      [4814, 4815, "Manawatu-Wanganui", "Levin"],
      [4816, 4817, "Manawatu-Wanganui", "Feilding"],
      [4818, 4818, "Manawatu-Wanganui", "Marton"],
      [4820, 4820, "Manawatu-Wanganui", "Palmerston North"],
      [4821, 4821, "Manawatu-Wanganui", "Levin"],
      [4822, 4822, "Manawatu-Wanganui", "Feilding"],
      [4825, 4826, "Manawatu-Wanganui", "Taumarunui"],
      [4847, 4847, "Manawatu-Wanganui", "Palmerston North"],
      [4848, 4849, "Manawatu-Wanganui", "Levin"],
      [4860, 4860, "Manawatu-Wanganui", "Levin"],
      [4861, 4861, "Manawatu-Wanganui", "Taumarunui"],
      [4862, 4862, "Manawatu-Wanganui", "Feilding"],
      [4863, 4863, "Manawatu-Wanganui", "Marton"],
      [4864, 4864, "Manawatu-Wanganui", "Levin"],
      [4865, 4865, "Manawatu-Wanganui", "Feilding"],
      [4866, 4867, "Manawatu-Wanganui", "Palmerston North"],
      [4884, 4884, "Manawatu-Wanganui", "Feilding"],
      [4891, 4891, "Manawatu-Wanganui", "Levin"],
      [4893, 4893, "Manawatu-Wanganui", "Levin"],
      [4894, 4894, "Manawatu-Wanganui", "Marton"],
      [4900, 4900, "Manawatu-Wanganui", "Dannevirke"],
      [4910, 4910, "Manawatu-Wanganui", "Dannevirke"],
      [4920, 4920, "Manawatu-Wanganui", "Dannevirke"],
      [4930, 4930, "Manawatu-Wanganui", "Dannevirke"],
      [4940, 4945, "Manawatu-Wanganui", "Dannevirke"],
      [4970, 4970, "Hawke's Bay", "Waipukurau"],
      [4971, 4979, "Manawatu-Wanganui", "Dannevirke"],
      [4981, 4993, "Manawatu-Wanganui", "Dannevirke"],
      [4994, 4994, "Wellington", "Masterton"],
      [4995, 4995, "Manawatu-Wanganui", "Dannevirke"],
      [4996, 4996, "Wellington", "Masterton"],
      [4997, 4999, "Manawatu-Wanganui", "Dannevirke"],
      [5010, 5014, "Wellington", "Lower Hutt"],
      [5016, 5016, "Wellington", "Wellington"],
      [5018, 5019, "Wellington", "Upper Hutt"],
      [5022, 5022, "Wellington", "Porirua"],
      [5024, 5024, "Wellington", "Porirua"],
      [5026, 5026, "Wellington", "Porirua"],
      [5028, 5028, "Wellington", "Wellington"],
      [5032, 5032, "Wellington", "Paraparaumu"],
      [5034, 5034, "Wellington", "Paraparaumu"],
      [5036, 5036, "Wellington", "Paraparaumu"],
      [5040, 5050, "Wellington", "Lower Hutt"],
      [5140, 5140, "Wellington", "Upper Hutt"],
      [5141, 5141, "Wellington", "Lower Hutt"],
      [5142, 5143, "Wellington", "Upper Hutt"],
      [5240, 5240, "Wellington", "Porirua"],
      [5242, 5243, "Wellington", "Porirua"],
      [5245, 5245, "Wellington", "Porirua"],
      [5247, 5247, "Wellington", "Porirua"],
      [5249, 5249, "Wellington", "Wellington"],
      [5250, 5250, "Wellington", "Paraparaumu"],
      [5252, 5252, "Wellington", "Paraparaumu"],
      [5254, 5255, "Wellington", "Paraparaumu"],
      [5258, 5258, "Wellington", "Paraparaumu"],
      [5371, 5372, "Wellington", "Upper Hutt"],
      [5373, 5373, "Wellington", "Lower Hutt"],
      [5381, 5381, "Wellington", "Porirua"],
      [5391, 5391, "Wellington", "Paraparaumu"],
      [5510, 5510, "Manawatu-Wanganui", "Levin"],
      [5512, 5512, "Wellington", "Paraparaumu"],
      [5540, 5541, "Manawatu-Wanganui", "Levin"],
      [5542, 5544, "Wellington", "Paraparaumu"],
      [5570, 5572, "Manawatu-Wanganui", "Levin"],
      [5573, 5573, "Wellington", "Paraparaumu"],
      [5574, 5575, "Manawatu-Wanganui", "Levin"],
      [5581, 5581, "Wellington", "Paraparaumu"],
      [5710, 5712, "Wellington", "Featherston"],
      [5713, 5713, "Wellington", "Carterton"],
      [5740, 5742, "Wellington", "Featherston"],
      [5743, 5743, "Wellington", "Carterton"],
      [5771, 5773, "Wellington", "Featherston"],
      [5781, 5784, "Wellington", "Featherston"],
      [5791, 5791, "Wellington", "Carterton"],
      [5792, 5792, "Wellington", "Featherston"],
      [5794, 5794, "Wellington", "Featherston"],
      [5810, 5810, "Wellington", "Masterton"],
      [5840, 5840, "Wellington", "Masterton"],
      [5842, 5842, "Wellington", "Masterton"],
      [5871, 5871, "Wellington", "Masterton"],
      [5872, 5872, "Wellington", "Carterton"],
      [5881, 5882, "Wellington", "Masterton"],
      [5883, 5883, "Wellington", "Carterton"],
      [5884, 5886, "Wellington", "Masterton"],
      [5887, 5887, "Wellington", "Carterton"],
      [5888, 5890, "Wellington", "Masterton"],
      [5894, 5894, "Wellington", "Masterton"],
      [6011, 6012, "Wellington", "Wellington"],
      [6021, 6023, "Wellington", "Wellington"],
      [6035, 6035, "Wellington", "Wellington"],
      [6037, 6037, "Wellington", "Wellington"],
      [6140, 6150, "Wellington", "Wellington"],
      [6160, 6160, "Wellington", "Wellington"],
      [6241, 6244, "Wellington", "Wellington"],
      [6440, 6443, "Wellington", "Wellington"],
      [6972, 6972, "Wellington", "Wellington"],
      [7005, 7005, "Tasman", "Richmond"],
      [7007, 7007, "Tasman", "Richmond"],
      [7010, 7011, "Nelson", "Nelson"],
      [7020, 7020, "Nelson", "Nelson"],
      [7022, 7022, "Tasman", "Richmond"],
      [7025, 7025, "Tasman", "Richmond"],
      [7040, 7045, "Nelson", "Nelson"],
      [7046, 7046, "Nelson", "Nelson South"],
      [7047, 7047, "Nelson", "Nelson"],
      [7048, 7055, "Tasman", "Richmond"],
      [7071, 7071, "Nelson", "Nelson"],
      [7072, 7073, "Tasman", "Richmond"],
      [7077, 7077, "Tasman", "Richmond"],
      [7081, 7081, "Nelson", "Nelson"],
      [7091, 7091, "Tasman", "Richmond"],
      [7095, 7096, "Tasman", "Richmond"],
      [7100, 7100, "Marlborough", "Blenheim"],
      [7110, 7110, "Tasman", "Richmond"],
      [7120, 7120, "Tasman", "Richmond"],
      [7142, 7144, "Tasman", "Richmond"],
      [7145, 7145, "Marlborough", "Blenheim"],
      [7146, 7146, "Tasman", "Richmond"],
      [7150, 7150, "Marlborough", "Blenheim"],
      [7173, 7173, "Tasman", "Richmond"],
      [7175, 7175, "Tasman", "Richmond"],
      [7178, 7178, "Marlborough", "Blenheim"],
      [7182, 7183, "Tasman", "Richmond"],
      [7192, 7195, "Marlborough", "Blenheim"],
      [7196, 7198, "Tasman", "Richmond"],
      [7201, 7202, "Marlborough", "Blenheim"],
      [7204, 7204, "Marlborough", "Blenheim"],
      [7206, 7206, "Marlborough", "Blenheim"],
      [7210, 7210, "Marlborough", "Blenheim"],
      [7220, 7220, "Marlborough", "Blenheim"],
      [7240, 7244, "Marlborough", "Blenheim"],
      [7246, 7248, "Marlborough", "Blenheim"],
      [7250, 7251, "Marlborough", "Blenheim"],
      [7260, 7260, "Canterbury", "Kaikoura"],
      [7271, 7276, "Marlborough", "Blenheim"],
      [7281, 7282, "Marlborough", "Blenheim"],
      [7284, 7285, "Marlborough", "Blenheim"],
      [7300, 7300, "Canterbury", "Kaikoura"],
      [7310, 7310, "Canterbury", "Amberley"],
      [7332, 7332, "Canterbury", "Amberley"],
      [7334, 7334, "Canterbury", "Amberley"],
      [7340, 7340, "Canterbury", "Kaikoura"],
      [7341, 7341, "Canterbury", "Amberley"],
      [7343, 7343, "Canterbury", "Amberley"],
      [7345, 7345, "Canterbury", "Amberley"],
      [7348, 7348, "Canterbury", "Amberley"],
      [7360, 7360, "Canterbury", "Amberley"],
      [7371, 7371, "Canterbury", "Kaikoura"],
      [7373, 7373, "Canterbury", "Amberley"],
      [7374, 7374, "Canterbury", "Kaikoura"],
      [7379, 7379, "Canterbury", "Amberley"],
      [7381, 7385, "Canterbury", "Amberley"],
      [7387, 7387, "Canterbury", "Amberley"],
      [7391, 7392, "Canterbury", "Amberley"],
      [7395, 7395, "Canterbury", "Amberley"],
      [7400, 7400, "Canterbury", "Rangiora"],
      [7402, 7402, "Canterbury", "Rangiora"],
      [7410, 7410, "Canterbury", "Amberley"],
      [7420, 7420, "Canterbury", "Amberley"],
      [7430, 7430, "Canterbury", "Rangiora"],
      [7440, 7440, "Canterbury", "Rangiora"],
      [7441, 7442, "Canterbury", "Amberley"],
      [7443, 7445, "Canterbury", "Rangiora"],
      [7446, 7447, "Canterbury", "Amberley"],
      [7448, 7448, "Canterbury", "Rangiora"],
      [7471, 7474, "Canterbury", "Rangiora"],
      [7481, 7481, "Canterbury", "Rangiora"],
      [7482, 7483, "Canterbury", "Amberley"],
      [7491, 7491, "Canterbury", "Amberley"],
      [7495, 7495, "Canterbury", "Rangiora"],
      [7500, 7500, "Canterbury", "Rolleston"],
      [7510, 7510, "Canterbury", "Rolleston"],
      [7520, 7520, "Canterbury", "Christchurch"],
      [7540, 7540, "Canterbury", "Christchurch"],
      [7541, 7541, "Canterbury", "Rolleston"],
      [7542, 7542, "Canterbury", "Christchurch"],
      [7543, 7544, "Canterbury", "Rolleston"],
      [7545, 7546, "Canterbury", "Christchurch"],
      [7548, 7548, "Canterbury", "Rolleston"],
      [7571, 7572, "Canterbury", "Rolleston"],
      [7580, 7580, "Canterbury", "Rolleston"],
      [7581, 7583, "Canterbury", "Christchurch"],
      [7591, 7591, "Canterbury", "Christchurch"],
      [7600, 7600, "Canterbury", "Rolleston"],
      [7602, 7602, "Canterbury", "Rolleston"],
      [7604, 7604, "Canterbury", "Rolleston"],
      [7608, 7608, "Canterbury", "Rolleston"],
      [7610, 7610, "Canterbury", "Rangiora"],
      [7614, 7614, "Canterbury", "Rolleston"],
      [7616, 7616, "Canterbury", "Rolleston"],
      [7630, 7630, "Canterbury", "Rangiora"],
      [7632, 7632, "Canterbury", "Rolleston"],
      [7640, 7640, "Canterbury", "Rolleston"],
      [7641, 7641, "Canterbury", "Rangiora"],
      [7642, 7643, "Canterbury", "Rolleston"],
      [7644, 7644, "Canterbury", "Rangiora"],
      [7645, 7647, "Canterbury", "Rolleston"],
      [7649, 7649, "Canterbury", "Rolleston"],
      [7656, 7657, "Canterbury", "Rolleston"],
      [7670, 7672, "Canterbury", "Christchurch"],
      [7673, 7673, "Canterbury", "Rolleston"],
      [7674, 7674, "Canterbury", "Christchurch"],
      [7675, 7676, "Canterbury", "Rolleston"],
      [7681, 7683, "Canterbury", "Rolleston"],
      [7691, 7692, "Canterbury", "Rangiora"],
      [7700, 7700, "Canterbury", "Ashburton"],
      [7710, 7710, "Canterbury", "Ashburton"],
      [7730, 7730, "Canterbury", "Ashburton"],
      [7740, 7743, "Canterbury", "Ashburton"],
      [7745, 7748, "Canterbury", "Ashburton"],
      [7771, 7778, "Canterbury", "Ashburton"],
      [7781, 7781, "Canterbury", "Ashburton"],
      [7782, 7783, "Canterbury", "Rolleston"],
      [7784, 7784, "Canterbury", "Ashburton"],
      [7791, 7791, "Canterbury", "Ashburton"],
      [7802, 7805, "West Coast", "Greymouth"],
      [7810, 7812, "West Coast", "Hokitika"],
      [7822, 7823, "West Coast", "Westport"],
      [7825, 7825, "West Coast", "Westport"],
      [7830, 7830, "West Coast", "Westport"],
      [7832, 7832, "West Coast", "Hokitika"],
      [7840, 7841, "West Coast", "Greymouth"],
      [7842, 7842, "West Coast", "Hokitika"],
      [7843, 7843, "West Coast", "Greymouth"],
      [7844, 7844, "West Coast", "Hokitika"],
      [7845, 7845, "West Coast", "Greymouth"],
      [7846, 7848, "West Coast", "Westport"],
      [7851, 7851, "West Coast", "Westport"],
      [7856, 7857, "West Coast", "Hokitika"],
      [7859, 7863, "West Coast", "Hokitika"],
      [7864, 7867, "West Coast", "Westport"],
      [7871, 7871, "West Coast", "Westport"],
      [7872, 7873, "West Coast", "Greymouth"],
      [7875, 7875, "West Coast", "Greymouth"],
      [7881, 7886, "West Coast", "Hokitika"],
      [7891, 7893, "West Coast", "Westport"],
      [7895, 7895, "West Coast", "Westport"],
      [7901, 7901, "Canterbury", "Twizel"],
      [7903, 7903, "Canterbury", "Timaru"],
      [7910, 7910, "Canterbury", "Timaru"],
      [7912, 7912, "Canterbury", "Timaru"],
      [7920, 7920, "Canterbury", "Timaru"],
      [7924, 7924, "Canterbury", "Waimate"],
      [7925, 7925, "Canterbury", "Twizel"],
      [7930, 7930, "Canterbury", "Timaru"],
      [7940, 7943, "Canterbury", "Timaru"],
      [7944, 7946, "Canterbury", "Twizel"],
      [7947, 7948, "Canterbury", "Timaru"],
      [7949, 7949, "Canterbury", "Twizel"],
      [7956, 7958, "Canterbury", "Timaru"],
      [7960, 7960, "Canterbury", "Waimate"],
      [7971, 7971, "Canterbury", "Waimate"],
      [7972, 7974, "Canterbury", "Timaru"],
      [7977, 7980, "Canterbury", "Waimate"],
      [7982, 7983, "Canterbury", "Timaru"],
      [7984, 7984, "Canterbury", "Waimate"],
      [7985, 7986, "Canterbury", "Timaru"],
      [7987, 7987, "Canterbury", "Twizel"],
      [7988, 7988, "Canterbury", "Waimate"],
      [7990, 7992, "Canterbury", "Timaru"],
      [7999, 7999, "Canterbury", "Timaru"],
      [8011, 8011, "Canterbury", "Christchurch"],
      [8013, 8014, "Canterbury", "Christchurch"],
      [8022, 8024, "Canterbury", "Christchurch"],
      [8025, 8025, "Canterbury", "Rolleston"],
      [8041, 8041, "Canterbury", "Christchurch"],
      [8042, 8042, "Canterbury", "Rolleston"],
      [8051, 8053, "Canterbury", "Christchurch"],
      [8061, 8062, "Canterbury", "Christchurch"],
      [8081, 8083, "Canterbury", "Christchurch"],
      [8140, 8149, "Canterbury", "Christchurch"],
      [8240, 8247, "Canterbury", "Christchurch"],
      [8440, 8445, "Canterbury", "Christchurch"],
      [8540, 8540, "Canterbury", "Christchurch"],
      [8542, 8546, "Canterbury", "Christchurch"],
      [8640, 8643, "Canterbury", "Christchurch"],
      [8840, 8842, "Canterbury", "Christchurch"],
      [8941, 8941, "Canterbury", "Christchurch"],
      [8942, 8942, "Canterbury", "Waitangi"],
      [8971, 8972, "Canterbury", "Christchurch"],
      [9010, 9014, "Otago", "Dunedin"],
      [9016, 9016, "Otago", "Dunedin"],
      [9018, 9019, "Otago", "Dunedin"],
      [9022, 9024, "Otago", "Dunedin"],
      [9035, 9035, "Otago", "Dunedin"],
      [9040, 9050, "Otago", "Dunedin"],
      [9052, 9054, "Otago", "Dunedin"],
      [9058, 9059, "Otago", "Dunedin"],
      [9062, 9062, "Otago", "Dunedin"],
      [9067, 9067, "Otago", "Dunedin"],
      [9069, 9069, "Otago", "Dunedin"],
      [9073, 9073, "Otago", "Dunedin"],
      [9074, 9074, "Otago", "Balclutha"],
      [9076, 9077, "Otago", "Dunedin"],
      [9081, 9082, "Otago", "Dunedin"],
      [9085, 9085, "Otago", "Dunedin"],
      [9091, 9092, "Otago", "Dunedin"],
      [9210, 9210, "Otago", "Balclutha"],
      [9220, 9220, "Otago", "Balclutha"],
      [9230, 9231, "Otago", "Balclutha"],
      [9240, 9242, "Otago", "Balclutha"],
      [9271, 9274, "Otago", "Balclutha"],
      [9281, 9282, "Otago", "Balclutha"],
      [9291, 9292, "Otago", "Balclutha"],
      [9300, 9300, "Otago", "Queenstown"],
      [9302, 9302, "Otago", "Queenstown"],
      [9304, 9305, "Otago", "Queenstown"],
      [9310, 9310, "Otago", "Alexandra"],
      [9320, 9320, "Otago", "Alexandra"],
      [9330, 9330, "Otago", "Alexandra"],
      [9332, 9332, "Otago", "Alexandra"],
      [9340, 9342, "Otago", "Alexandra"],
      [9343, 9346, "Otago", "Queenstown"],
      [9347, 9347, "Otago", "Alexandra"],
      [9348, 9351, "Otago", "Queenstown"],
      [9352, 9355, "Otago", "Alexandra"],
      [9356, 9356, "Southland", "Gore"],
      [9371, 9372, "Otago", "Queenstown"],
      [9376, 9377, "Otago", "Alexandra"],
      [9381, 9381, "Otago", "Alexandra"],
      [9382, 9383, "Otago", "Queenstown"],
      [9384, 9384, "Otago", "Alexandra"],
      [9386, 9387, "Otago", "Alexandra"],
      [9391, 9393, "Otago", "Alexandra"],
      [9395, 9396, "Otago", "Alexandra"],
      [9397, 9397, "Otago", "Dunedin"],
      [9398, 9398, "Otago", "Alexandra"],
      [9400, 9401, "Otago", "Oamaru"],
      [9410, 9410, "Otago", "Oamaru"],
      [9412, 9412, "Canterbury", "Oamaru"],
      [9430, 9430, "Otago", "Oamaru"],
      [9435, 9435, "Canterbury", "Oamaru"],
      [9441, 9441, "Otago", "Alexandra"],
      [9442, 9445, "Otago", "Oamaru"],
      [9446, 9448, "Canterbury", "Oamaru"],
      [9471, 9472, "Otago", "Dunedin"],
      [9481, 9483, "Otago", "Oamaru"],
      [9491, 9491, "Canterbury", "Oamaru"],
      [9492, 9495, "Otago", "Oamaru"],
      [9498, 9498, "Canterbury", "Waimate"],
      [9500, 9500, "Otago", "Alexandra"],
      [9510, 9510, "Otago", "Dunedin"],
      [9522, 9522, "Otago", "Balclutha"],
      [9532, 9532, "Otago", "Balclutha"],
      [9534, 9535, "Otago", "Balclutha"],
      [9541, 9541, "Otago", "Dunedin"],
      [9542, 9543, "Otago", "Balclutha"],
      [9544, 9544, "Otago", "Alexandra"],
      [9546, 9546, "Otago", "Balclutha"],
      [9548, 9548, "Otago", "Balclutha"],
      [9571, 9572, "Otago", "Alexandra"],
      [9583, 9586, "Otago", "Balclutha"],
      [9587, 9588, "Otago", "Alexandra"],
      [9591, 9591, "Otago", "Balclutha"],
      [9593, 9593, "Otago", "Balclutha"],
      [9596, 9597, "Otago", "Dunedin"],
      [9598, 9598, "Otago", "Oamaru"],
      [9600, 9600, "Southland", "Invercargill"],
      [9610, 9610, "Southland", "Invercargill"],
      [9620, 9620, "Southland", "Invercargill"],
      [9630, 9630, "Southland", "Invercargill"],
      [9635, 9635, "Southland", "Invercargill"],
      [9640, 9645, "Southland", "Invercargill"],
      [9672, 9672, "Southland", "Invercargill"],
      [9679, 9679, "Southland", "Invercargill"],
      [9682, 9683, "Southland", "Invercargill"],
      [9689, 9689, "Southland", "Invercargill"],
      [9691, 9691, "Southland", "Invercargill"],
      [9710, 9710, "Southland", "Gore"],
      [9712, 9712, "Southland", "Gore"],
      [9720, 9720, "Southland", "Invercargill"],
      [9730, 9730, "Southland", "Invercargill"],
      [9740, 9740, "Southland", "Gore"],
      [9741, 9747, "Southland", "Invercargill"],
      [9748, 9748, "Otago", "Queenstown"],
      [9749, 9750, "Southland", "Invercargill"],
      [9752, 9752, "Southland", "Invercargill"],
      [9771, 9773, "Southland", "Gore"],
      [9774, 9774, "Southland", "Invercargill"],
      [9775, 9776, "Southland", "Gore"],
      [9777, 9779, "Southland", "Invercargill"],
      [9781, 9783, "Southland", "Invercargill"],
      [9791, 9794, "Southland", "Invercargill"],
      [9810, 9810, "Southland", "Invercargill"],
      [9812, 9812, "Southland", "Invercargill"],
      [9814, 9814, "Southland", "Invercargill"],
      [9816, 9816, "Southland", "Invercargill"],
      [9818, 9818, "Southland", "Halfmoon Bay (Oban)"],
      [9822, 9822, "Southland", "Invercargill"],
      [9825, 9825, "Southland", "Invercargill"],
      [9831, 9831, "Southland", "Invercargill"],
      [9840, 9849, "Southland", "Invercargill"],
      [9871, 9872, "Southland", "Invercargill"],
      [9874, 9877, "Southland", "Invercargill"],
      [9879, 9879, "Southland", "Invercargill"],
      [9881, 9881, "Southland", "Invercargill"],
      [9883, 9884, "Southland", "Invercargill"],
      [9891, 9891, "Southland", "Invercargill"],
      [9892, 9892, "Southland", "Gore"],
      [9893, 9893, "Southland", "Invercargill"]
    ];
    function regionForPostcode(zip) {
      if (NZ_POSTCODE_LOCALITIES[zip]) return NZ_POSTCODE_LOCALITIES[zip];
      var n = parseInt(zip, 10);
      if (isNaN(n)) return null;
      for (var i = 0; i < NZ_POSTCODE_LOCALITY_RANGES.length; i++) {
        var r = NZ_POSTCODE_LOCALITY_RANGES[i];
        if (n >= r[0] && n <= r[1]) return { province: r[2], city: r[3] };
      }
      return null;
    }

    
window.fwRegionForPostcode=regionForPostcode;
})();
